import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  exportApplicantsDataFailure,
  exportApplicantsDataSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';
import { saveDownloadIds } from 'redux/direct-download/actions';
import { networkErrorHandler } from 'utils/errrorHandlers';
import { getOrgName } from 'utils/helpers';

const { API_BASE_URL } = urls || {};

function* exportData({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/candidate-export`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });
  if (response.success) {
    cb();
    yield put(exportApplicantsDataSuccess());
    yield put(saveDownloadIds({id : response.raw.id, org: getOrgName()}));
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
    yield put(exportApplicantsDataFailure(response.message));
  }
}

export function* onExportData() {
  yield takeEvery(
    ApplicantsActionTypes.EXPORT_APPLICANTS_DATA_START,
    exportData
  );
}
